(() => {
  const wishlistKey = 'mayka:wishlist:v1';
  const compareKey = 'mayka:compare:v1';
  const maxCompared = 4;
  const list = (key) => { try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch { return []; } };
  const save = (key, value) => {
  localStorage.setItem(key, JSON.stringify([...new Set(value)]));
  updateHeaderFavorites();
  document.dispatchEvent(new CustomEvent('mayka:lists-changed'));
};
  const favorites = () => list(wishlistKey);
  const compared = () => list(compareKey);
  const money = (value) => new Intl.NumberFormat(document.documentElement.lang || 'es-ES', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format((value || 0) / 100);
  const product = async (handle) => {
    const response = await fetch('/products/' + encodeURIComponent(handle) + '.js');
    if (!response.ok) throw new Error('Producto no disponible');
    const data = await response.json();
    const variant = data.variants.find((item) => item.available) || data.variants[0] || {};
    const price = variant.price || data.price || 0;
    const compareAt = variant.compare_at_price || data.compare_at_price || 0;
    const colors = data.options?.find((option) => /color|colour/i.test(option.name))?.values?.join(', ') || '—';
    const sizeIndex = data.options?.findIndex((option) => /talla|size/i.test(option.name)) ?? -1;
    const variants = data.variants.filter((item) => item.available).map((item) => {
      const size = sizeIndex >= 0 ? item['option' + (sizeIndex + 1)] : (data.variants.length === 1 ? 'Talla única' : item.title);
      const optionValues = (data.options || []).map((option, index) => item['option' + (index + 1)]);
      const details = optionValues.filter((option, index) => index !== sizeIndex && option && option !== 'Default Title');
      return { id: item.id, label: details.length ? size + ' · ' + details.join(' · ') : size };
    });
    let sizes = variants.map((item) => item.label).filter(Boolean).join(', ') || '—';
    try {
      const sizesResponse = await fetch('/products/' + encodeURIComponent(handle) + '?view=mayka-compare-data');
      if (sizesResponse.ok) {
        const sizesData = await sizesResponse.json();
        const rawSizes = sizesData.tallas;
        if (Array.isArray(rawSizes)) sizes = rawSizes.filter(Boolean).join(', ') || sizes;
        else if (rawSizes) sizes = String(rawSizes);
      }
    } catch {}
    const text = document.createElement('div');
    text.innerHTML = data.description || '';
    return { handle: data.handle, title: data.title, url: data.url, image: data.featured_image || data.images?.[0] || '', vendor: data.vendor || '—', type: data.type || '—', variantId: variant.id || null, price, compareAt, discount: compareAt > price ? Math.round((1 - price / compareAt) * 100) : 0, available: data.available, colors, sizes, variants, description: text.textContent.replace(/\s+/g, ' ').trim().slice(0, 180) || '—' };
  };
  const updateButtons = () => document.querySelectorAll('[data-mayka-wishlist-toggle]').forEach((button) => {
    const active = favorites().includes(button.dataset.productHandle);
    button.setAttribute('aria-pressed', String(active));
    button.classList.toggle('is-saved', active);
    const label = button.querySelector('[data-mayka-wishlist-label]');
    if (label) label.textContent = active ? 'Guardado en favoritos' : 'Guardar en favoritos';
  });
  const updateHeaderFavorites = () => {
    const count = favorites().length;
    document.querySelectorAll('[data-mayka-header-favorites]').forEach((icon) => {
      icon.classList.toggle('has-favorites', count > 0);
      const badge = icon.querySelector('[data-mayka-header-favorites-count]');
      if (badge) {
        badge.textContent = count;
        badge.hidden = count === 0;
      }
    });
  };
  const element = (tag, className, value) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (value !== undefined) node.textContent = value;
    return node;
  };
  const favoriteCard = (item, allowCompare) => {
    const card = element('article', 'mayka-wishlist-card');
    const link = element('a', 'mayka-wishlist-card__image');
    link.href = item.url;
    const image = document.createElement('img');
    image.src = item.image; image.alt = item.title; image.width = 480; image.height = 600; image.loading = 'lazy';
    link.append(image); card.append(link);
    const content = element('div', 'mayka-wishlist-card__content');
    const title = element('a', 'mayka-wishlist-card__title', item.title);
    title.href = item.url;
    content.append(title, element('p', 'mayka-wishlist-card__brand', item.vendor));
    const price = element('p', 'mayka-wishlist-card__price', money(item.price));
    if (item.compareAt > item.price) price.append(' ', element('del', 'mayka-wishlist-card__old-price', money(item.compareAt)));
    content.append(price);
    if (item.discount) content.append(element('p', 'mayka-wishlist-card__discount', '-' + item.discount + '%'));
    content.append(element('p', 'mayka-wishlist-card__availability', item.available ? 'Disponible' : 'Agotado'));
    card.append(content);
    const actions = element('div', 'mayka-wishlist-card__actions');
    const remove = element('button', 'mayka-wishlist-card__remove', 'Quitar');
    remove.type = 'button'; remove.dataset.maykaWishlistRemove = item.handle;
    actions.append(remove);
    if (allowCompare) {
      const selected = compared().includes(item.handle);
      const compare = element('button', 'mayka-wishlist-card__compare' + (selected ? ' is-selected' : ''), selected ? '✓ Seleccionado' : 'Añadir a la comparación');
      compare.type = 'button'; compare.dataset.maykaCompareToggle = item.handle; compare.setAttribute('aria-pressed', String(selected));
      actions.append(compare);
    }
    card.append(actions);
    return card;
  };
  const renderFavorites = async (root) => {
    const grid = root.querySelector('[data-mayka-wishlist-list]');
    const empty = root.querySelector('[data-mayka-wishlist-empty]');
    const action = root.querySelector('[data-mayka-compare-action]');
    const handles = favorites();
    const renderId = String((Number(root.dataset.maykaWishlistRenderId) || 0) + 1);
    root.dataset.maykaWishlistRenderId = renderId;

    if (!handles.length) {
      grid.replaceChildren();
      empty.hidden = false;
      if (action) action.hidden = true;
      return;
    }

    empty.hidden = true;
    const products = await Promise.all(handles.map(async (handle) => { try { return await product(handle); } catch { return null; } }));
    if (root.dataset.maykaWishlistRenderId !== renderId) return;

    const cards = document.createDocumentFragment();
    products.filter(Boolean).forEach((item) => cards.append(favoriteCard(item, root.dataset.enableComparison === 'true')));
    grid.replaceChildren(cards);

    if (action) {
      const selected = compared().filter((handle) => handles.includes(handle));
      action.hidden = root.dataset.enableComparison !== 'true' || selected.length < 2;
    }
  };
  const renderCompare = async (root) => {
    const grid = root.querySelector('[data-mayka-compare-list]');
    const empty = root.querySelector('[data-mayka-compare-empty]');
    const handles = compared();
    grid.replaceChildren();
    if (handles.length < 2) { empty.hidden = false; return; }
    empty.hidden = true;
    const products = await Promise.all(handles.map(async (handle) => { try { return await product(handle); } catch { return null; } }));
    products.filter(Boolean).forEach((item) => {
      const column = element('article', 'mayka-compare__column');
      const image = document.createElement('img');
      image.className = 'mayka-compare__image'; image.src = item.image; image.alt = item.title; image.width = 280; image.height = 140; image.loading = 'lazy';
      column.append(image);
      const title = element('a', 'mayka-compare__title', item.title);
      title.href = item.url;
      column.append(title);
      const remove = element('button', 'mayka-compare__remove', 'Quitar de la comparación');
      remove.type = 'button'; remove.dataset.maykaCompareRemove = item.handle;
      column.append(remove);
      [['Marca', item.vendor], ['Categoría', item.type], ['Precio', money(item.price)], ['Descuento', item.discount ? '-' + item.discount + '%' : '—'], ['Tallas', item.sizes], ['Descripción', item.description]].forEach(([label, value]) => {
        const row = element('div', 'mayka-compare__row');
        const valueClass = label === 'Descuento' && item.discount ? 'mayka-compare__value mayka-compare__value--discount' : 'mayka-compare__value';
        row.append(element('dt', 'mayka-compare__label', label), element('dd', valueClass, value));
        column.append(row);
      });

      if (item.available && item.variants.length) {
        const sizeField = element('div', 'mayka-compare__size');
        const sizeLabel = element('label', 'mayka-compare__size-label', 'Elige tu talla');
        const sizeSelect = element('select', 'mayka-compare__size-select');
        const sizeId = 'mayka-compare-size-' + item.handle;
        sizeSelect.id = sizeId; sizeSelect.dataset.maykaCompareSize = item.handle;
        sizeLabel.htmlFor = sizeId;
        const placeholder = new Option('Selecciona una talla', '');
        placeholder.disabled = true; placeholder.selected = true;
        sizeSelect.append(placeholder);
        item.variants.forEach((variant) => sizeSelect.append(new Option(variant.label, variant.id)));
        sizeField.append(sizeLabel, sizeSelect);
        column.append(sizeField);

        const buy = element('button', 'mayka-compare__buy is-disabled', 'Comprar');
        buy.type = 'button'; buy.disabled = true; buy.dataset.maykaCompareBuy = item.handle; buy.setAttribute('aria-disabled', 'true');
        column.append(buy);
      } else {
        const buy = element('span', 'mayka-compare__buy is-disabled', 'Agotado');
        buy.setAttribute('aria-disabled', 'true');
        column.append(buy);
      }
      grid.append(column);
    });
  };
  const render = () => {
    updateButtons();
    updateHeaderFavorites();
    document.querySelectorAll('[data-mayka-wishlist-page]').forEach(renderFavorites);
    document.querySelectorAll('[data-mayka-compare-page]').forEach(renderCompare);
  };
  const updateCompareBuy = (select) => {
    const column = select.closest('.mayka-compare__column');
    const buy = column?.querySelector('[data-mayka-compare-buy]');
    const selected = Boolean(select.value);
    if (buy) {
      buy.disabled = !selected;
      buy.classList.toggle('is-disabled', !selected);
      buy.setAttribute('aria-disabled', String(!selected));
    }
  };
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-mayka-compare-size]');
    if (select) updateCompareBuy(select);
  });
  document.addEventListener('click', (event) => {
    const favorite = event.target.closest('[data-mayka-wishlist-toggle]');
    if (favorite) {
      event.preventDefault();
      const handle = favorite.dataset.productHandle;
      save(wishlistKey, favorites().includes(handle) ? favorites().filter((item) => item !== handle) : [...favorites(), handle]);
      return;
    }
    const removeFavorite = event.target.closest('[data-mayka-wishlist-remove]');
    if (removeFavorite) {
      const handle = removeFavorite.dataset.maykaWishlistRemove;
      save(wishlistKey, favorites().filter((item) => item !== handle));
      save(compareKey, compared().filter((item) => item !== handle));
      return;
    }
    const compare = event.target.closest('[data-mayka-compare-toggle]');
    if (compare) {
      const handle = compare.dataset.maykaCompareToggle;
      if (compared().includes(handle)) save(compareKey, compared().filter((item) => item !== handle));
      else if (compared().length < maxCompared) save(compareKey, [...compared(), handle]);
      else window.alert('Puedes comparar hasta ' + maxCompared + ' productos.');
      return;
    }
    const compareBuy = event.target.closest('[data-mayka-compare-buy]');
    if (compareBuy) {
      const column = compareBuy.closest('.mayka-compare__column');
      const select = column?.querySelector('[data-mayka-compare-size]');
      if (!select?.value) {
        if (select) {
          select.classList.add('has-error');
          select.focus();
        }
        return;
      }
      window.location.assign('/cart/add?id=' + encodeURIComponent(select.value) + '&quantity=1');
      return;
    }
    const removeCompare = event.target.closest('[data-mayka-compare-remove]');
    if (removeCompare) save(compareKey, compared().filter((item) => item !== removeCompare.dataset.maykaCompareRemove));
  });
  document.addEventListener('mayka:lists-changed', render);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', render, { once: true }) : render();
})();